var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrade1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.431641,
    width: 125,
    height: 125,
    fill: "#D8D8D8",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1512_34545",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 12,
    width: 126,
    height: 110
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12.9316,
    width: 125,
    height: 108.333,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1512_34545)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.71484,
    y: 33.0879,
    width: 38.4058,
    height: 25.1136,
    rx: 9.375,
    stroke: "#FFD02F",
    strokeWidth: 6.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.8867,
    y: 33.0879,
    width: 38.4058,
    height: 25.1136,
    rx: 9.375,
    stroke: "#FFD02F",
    strokeWidth: 6.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8783 66.0063C21.5406 53.5687 18.4427 34.2631 25.955 18.6561C27.6905 15.0506 34.8783 17.6139 41.6522 17.6144C57.2771 17.6144 55.7146 17.6146 80.7146 17.6146C87.4855 17.615 97.0933 14.2292 99.2235 18.6561C106.274 33.3086 104.078 51.402 92.3231 64.008C77.0162 80.4226 51.2973 81.3173 34.8783 66.0063Z",
    fill: "#FFE96C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.4141,
    y: 13.3438,
    width: 103.571,
    height: 10.4545,
    rx: 5.07576,
    fill: "#FFD02F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.5039,
    y: 65.6133,
    width: 21.0145,
    height: 37.5,
    fill: "#FFE96C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.2422,
    y: 102.205,
    width: 31.5217,
    height: 10.4545,
    rx: 5.22727,
    fill: "#FFE96C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.3711,
    y: 110.047,
    width: 47.2826,
    height: 10.4545,
    rx: 5.22727,
    fill: "#FFD02F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9487 32.8225H60.0066V63.7617H53.571V38.9408H53.3898L46.2895 43.3974V37.687L53.9487 32.8225ZM63.3881 48.0907V47.003C63.3881 44.5153 65.0499 42.4306 67.9101 42.4306C70.8711 42.4306 72.4322 44.5153 72.4322 47.003V48.0907C72.4322 50.5783 70.8308 52.6329 67.9101 52.6329C64.9693 52.6329 63.3881 50.5481 63.3881 48.0907ZM67.326 63.7617H64.7075L78.8879 43.1356H81.5065L67.326 63.7617ZM66.3088 47.003V48.0907C66.3088 49.0777 66.7117 50.0848 67.9101 50.0848C69.1489 50.0848 69.5115 49.0777 69.5115 48.0907V47.003C69.5115 46.016 69.1892 44.9786 67.9101 44.9786C66.7016 44.9786 66.3088 46.0361 66.3088 47.003ZM73.9731 59.8943V58.8066C73.9731 56.3492 75.5946 54.2342 78.4851 54.2342C81.436 54.2342 83.0071 56.319 83.0071 58.8066V59.8943C83.0071 62.3517 81.3957 64.4667 78.4851 64.4667C75.5543 64.4667 73.9731 62.3517 73.9731 59.8943ZM76.8636 58.8066V59.8943C76.8636 60.8612 77.2564 61.8884 78.4851 61.8884C79.7138 61.8884 80.0965 60.8813 80.0965 59.8943V58.8066C80.0965 57.8196 79.7541 56.7823 78.4851 56.7823C77.2664 56.7823 76.8636 57.8196 76.8636 58.8066Z",
    fill: "#FF8D02"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrade1);
export default __webpack_public_path__ + "static/media/grade_1.1f570097e9f235d517e3ce721580cb09.svg";
export { ForwardRef as ReactComponent };